<div class="container-fluid">
  <h3>Aplicar a un crédito</h3>
  <h4 >Ingrese el monto y plazo del nuevo crédito. </h4>
  <div class="producto" >
    <form>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group" >
            <label for="exampleInputEmail1">Monto</label>
            <input [(ngModel)]="monto" type="number" class="form-control" name="monto">
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label for="exampleInputEmail1">Plazo</label>
            <input [(ngModel)]="plazo" type="number" class="form-control" name="plazo" min="0">
        </div>
        </div>
      </div>
    </form>
  </div>
  <div class="row">
    <div class="col-md-6">
      <div style="text-align: left;">
        <button class="btn round-button-back" (click)="goBack()">Regresar</button>
      </div>
    </div>
    <div class="col-md-6">
      <div style="text-align: right;">
        <button class="btn round-button" (click)="goToIngresos()">Continuar</button>
      </div>
    </div>
  </div>
</div>
